import { IconButton, InputAdornment, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { format, parseISO } from 'date-fns';
import { Controller } from 'react-hook-form';
import { SearchLG } from 'untitledui-js-base';
import { handleEnterAsTab } from '../../../utils/handleEnterAsTab';
import { UserPrefix } from '../AccidenCreatingStepCustomerInformations';

/** Rodné číslo + Datum narození */
export const BirthNumberFields = ({
  prefix,
  control,
  birthNumber,
  onSearch,
  showBirthDate = true,
  showSearchIcon = true
}: {
  prefix: UserPrefix | 'driver' | 'contactPerson';
  control: any;
  birthNumber: string | undefined;
  onSearch: () => void;
  showBirthDate?: boolean;
  showSearchIcon?: boolean;
}) => (
  <>
    <Controller
      control={control}
      name={`${prefix}.birthNumber`}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? ''}
          label="Rodné číslo"
          color="secondary"
          fullWidth
          InputLabelProps={{ shrink: true }}
          slotProps={{
            htmlInput: { maxLength: 11 },
            input: {
              endAdornment: showSearchIcon && (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={onSearch}
                    disabled={!birthNumber}
                    color="primary"
                  >
                    <SearchLG />
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
          onKeyDown={handleEnterAsTab}
        />
      )}
    />
    {showBirthDate && (
      <Controller
        control={control}
        name={`${prefix}.birthDate`}
        render={({ field }) => (
          <DatePicker
            label="Datum narození"
            value={field.value ? parseISO(field.value) : null}
            onChange={(date) => field.onChange(date ? format(date, 'yyyy-MM-dd') : '')}
            format="dd.MM.yyyy"
            maxDate={new Date()}
          />
        )}
      />
    )}
  </>
);
